export interface QualitySettings {
  jpegQuality: number;
  webpQuality: number;
  avifQuality: number;
  avifSpeed: number;
}

export const DEFAULT_QUALITY_SETTINGS: QualitySettings = {
  jpegQuality: 82,
  webpQuality: 82,
  avifQuality: 50,
  avifSpeed: 6,
};

export const QUALITY_FORMAT_BY_SETTING: Record<keyof QualitySettings, string> = {
  jpegQuality: "image/jpeg",
  webpQuality: "image/webp",
  avifQuality: "image/avif",
  avifSpeed: "image/avif",
};

const clamp = (value: number, min: number, max: number) =>
  Math.max(min, Math.min(max, Math.round(value)));

export const normalizeQualitySettings = (
  settings: Partial<QualitySettings> = {}
): QualitySettings => ({
  jpegQuality: clamp(settings.jpegQuality ?? DEFAULT_QUALITY_SETTINGS.jpegQuality, 1, 100),
  webpQuality: clamp(settings.webpQuality ?? DEFAULT_QUALITY_SETTINGS.webpQuality, 1, 100),
  avifQuality: clamp(settings.avifQuality ?? DEFAULT_QUALITY_SETTINGS.avifQuality, 1, 100),
  avifSpeed: clamp(settings.avifSpeed ?? DEFAULT_QUALITY_SETTINGS.avifSpeed, 0, 10),
});
